import React, { FC, useCallback } from 'react';

import { UploadItemProps } from './types';

import { Wrapper, Content, Header, Footer } from './styled';

import UploadHeaderContent from './UploadHeaderContent';
import UploadFooterContent from './UploadFooterContent';
import UploadButtonGroup from './UploadButtonGroup';
import UploadFileIcon from './UploadFileIcon';

const UploadItem: FC<UploadItemProps> = ({
  file,
  listType,
  originNode,
  isUploaded = false,
  canDeleteUploaded = false,
  showRefreshButton = true,
  actions: { preview, remove, download },
}) => {
  const onPreview = useCallback(() => {
    if (file.status === 'error') return;

    preview();
  }, [file.status, preview]);

  if (!listType) return originNode;

  if (file.status === 'removed') return null;

  return (
    <Wrapper listType={listType}>
      <UploadFileIcon file={file} listType={listType} onPreview={onPreview} />

      <Content>
        <Header>
          <UploadHeaderContent file={file} listType={listType} onPreview={onPreview} />
        </Header>

        <Footer>
          <UploadFooterContent file={file} listType={listType} />
        </Footer>
      </Content>

      <UploadButtonGroup
        file={file}
        isUploaded={isUploaded}
        canDeleteUploaded={canDeleteUploaded}
        onRemove={remove}
        onDownload={download}
        showRefreshButton={showRefreshButton}
      />
    </Wrapper>
  );
};

export default UploadItem;
